import React from 'react';
import PageSyle from './style';
import slideSystem from '../../components/pageSlideSystem/slideSystem';
import page00 from './pages/page00';
import page01 from './pages/page01';
import page02 from './pages/page02';
import page03 from './pages/page03';
import page04 from './pages/page04';
import page05 from './pages/page05';
import page06 from './pages/page06';
import page07 from './pages/page07';
import page08 from './pages/page08';
import page09 from './pages/page09';
import page10 from './pages/page10';
import page11 from './pages/page11';
import page12 from './pages/page12';
import page13 from './pages/page13';
import page14 from './pages/page14';
import page15 from './pages/page15';
import page16 from './pages/page16';
import page17 from './pages/page17';
import page18 from './pages/page18';
import page19 from './pages/page19';
import page20 from './pages/page20';
import page21 from './pages/page21';
import page22 from './pages/page22';
import page23 from './pages/page23';
import page24 from './pages/page24';
import page25 from './pages/page25';
import coursesInfo from '../payment/courseInformation';

export default function CHW() {
	let courseInfo = coursesInfo[2];

	let CHWSlides = slideSystem(
		[
			page00,
			page01,
			page02,
			page03,
			page04,
			page05,
			page06,
			page07,
			page08,
			page09,
			page10,
			page11,
			page12,
			page13,
			page14,
			page15,
			page16,
			page17,
			page18,
			page19,
			page20,
			page21,
			page22,
			page23,
			page24,
			page25,
		],
		{
			next: scrollToTop,
			back: scrollToTop,
		},
		{courseInfo: courseInfo}
	);

	function scrollToTop() {
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}

		window.scrollTo(0, 0);
	}

	return <>{CHWSlides}</>;
}
